import type { CapabilityRevisionFile } from '@/types';

export function parseManifest(raw: unknown): Record<string, unknown> | null {
    if (!raw) return null;
    if (typeof raw === 'object' && raw !== null && !Array.isArray(raw)) {
        return raw as Record<string, unknown>;
    }
    if (typeof raw === 'string') {
        try {
            return JSON.parse(raw) as Record<string, unknown>;
        } catch {
            return null;
        }
    }
    return null;
}

export function normalizeNewlines(s: string): string {
    return s.replace(/\r\n/g, '\n');
}

export function extractFilesAndManifest(data: Record<string, unknown>): {
    files: CapabilityRevisionFile[];
    manifest: Record<string, unknown> | null;
} {
    const wr = data.working_revision as
        | { files?: CapabilityRevisionFile[]; type_config?: unknown }
        | undefined;
    const topFiles = data.files as CapabilityRevisionFile[] | undefined;
    return {
        files: topFiles ?? wr?.files ?? [],
        manifest: parseManifest(wr?.type_config),
    };
}
